import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import {
	Card,
	Alert,
	Row,
	Col,
	CardTitle,
	CardHeader,
	FormGroup
} from "reactstrap";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton/CustomButton";
import { addorUpdateBusinessNature } from "../../redux/actions/addOrUpdateBusinessNatureAction";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton/BackButton";
import val from "../../getThemeDetails"

const AdminAddNewBusinessNature = () => {
	const [businessNature, setBusinessNature] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [addOrUpdateBusinessNatureStatus, setaddOrUpdateBusinessNatureStatus] =
		useState(false);
	const [
		addOrUpdateBusinessNatureResArray,
		setaddOrUpdateBusinessNatureResArray
	] = useState([]);
	const dispatch = useDispatch();

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const addorUpadateBusinessNature = useSelector(
		({ addorUpdateBusinessNature }) => addorUpdateBusinessNature
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const addBusinessNatureRequest = () => {
		setaddOrUpdateBusinessNatureStatus(true);
		const addBusinessNatureReq = {
			// adminId: 2,
			adminId: val.adminIDS,
			
			operationId: "",
			businessNature: businessNature
		};
		dispatch(addorUpdateBusinessNature(addBusinessNatureReq, authToken));
	};

	const addOrUpdateBusinessNatureStatusFunc = () => {
		if (addOrUpdateBusinessNatureStatus) {
			if (addorUpadateBusinessNature.data.status == "success") {
				setaddOrUpdateBusinessNatureResArray(
					[].concat(addorUpadateBusinessNature.data)
				);
				setNotificationOpen(true);
			}
			if (addorUpadateBusinessNature.data.status == "failed") {
				setaddOrUpdateBusinessNatureResArray(addorUpadateBusinessNature.data);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		addOrUpdateBusinessNatureStatusFunc();
	}, [addorUpadateBusinessNature.data.status]);

	useEffect(() => {
		console.log(addorUpadateBusinessNature, "/////////////////////////");
	}, [addorUpadateBusinessNature]);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "businessNature") {
			setBusinessNature(value);
		}
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setBusinessNature("");
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}>
							{/* <Button
                onClick={IndividualE}
                startIcon={<IoIosArrowBack />}
                variant="text"
                color="primary"
              >
                Go Back
              </Button> */}
						</Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					<br />
					<Grid container>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<h6
								align="center"
								className="text-center"
							// style={{ marginTop: "1.2rem", marginRight: "3rem" }}
							>
								{" "}
								Select Owner ID
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }}>
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											size="small"
											color="primary"
											autoFocus={true}
											label="Select Business Nature"
											fullWidth={true}
											name="businessNature"
											value={businessNature}
											onChange={handleChange}
										/>
									</FormControl>
								</FormGroup>
							</div>
							{/*  */}
							{/*  */}
							{/*  */}
							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								<Button
									style={{
										// marginLeft: "0.7rem",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									// color="primary"
									onClick={() => {
										addBusinessNatureRequest();
									}}
								>
									Save
								</Button>
							</div>
						</Grid>

						{/* <Grid item xs={12} md={2} lg={2}></Grid> */}
					</Grid>
				</Card>
			</Layout>
			{addOrUpdateBusinessNatureResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateBusinessNatureResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateBusinessNatureResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateBusinessNatureResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminAddNewBusinessNature;
